import React, {useMemo} from "react"
import {useTranslation} from "react-i18next"
import {useHistory} from "react-router-dom"
import styles from "./SSOStatePage.module.scss"

export enum SSOFailureReasonType {
    EmailMismatch = "EMAIL_MISMATCH",
    Unknown = "UNKNOWN",
}

export enum SSOType {
    Microsoft = "MICROSOFT",
    Google = "GOOGLE",
    Okta = "OKTA",
}

export const failureReasonParam = "reason"
export const ssoTypeParam = "sso_type"
export const ssoEmailParam = "sso_email"
export const tsnEmailParam = "tsn_email"

export const SSOErrorMessage: React.FC = () => {
    const {t} = useTranslation(["auth_portal"])
    const history = useHistory()

    const urlParams = useMemo(() => new URLSearchParams(history.location.search), [history])

    const reasonType = urlParams.get(failureReasonParam) as SSOFailureReasonType | null
    const ssoType = urlParams.get(ssoTypeParam) as SSOType | null
    const ssoEmail = urlParams.get(ssoEmailParam)
    const tsnEmail = urlParams.get(tsnEmailParam)

    if (reasonType === SSOFailureReasonType.EmailMismatch) {
        return (
            <>
                <span>
                    {ssoType === SSOType.Microsoft
                        ? t`auth_portal:auth_page.sso_disabled.email_mismatch_ms`
                        : t`auth_portal:auth_page.sso_disabled.email_mismatch`}
                </span>
                {ssoEmail && tsnEmail && (
                    <div className={styles.emailBox}>
                        <div className={styles.email}>
                            <span className={styles.bold}>
                                {t`auth_portal:auth_page.sso_disabled.azure_email`}:
                            </span>{" "}
                            <span className={styles.emailValue}>{ssoEmail}</span>
                        </div>
                        <div className={styles.email}>
                            <span className={styles.bold}>
                                {t`auth_portal:auth_page.sso_disabled.tsn_email`}:
                            </span>{" "}
                            <span className={styles.emailValue}>{tsnEmail}</span>
                        </div>
                    </div>
                )}
            </>
        )
    }

    return <p>{t`auth_portal:auth_page.sso_disabled.unknown_error`}</p>
}
